import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Contact from "./components/Contact";
import Product from "./components/Product";
import Nav from "./components/Nav";
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme =createTheme({
  palette: {
    primary: {
      main:"#253f61",
      light:"hsl(214, 45%, 50%)"
    },
    secondary: {
      main:"#0c121a"
    },
    
      textAlign:'center'
  
  }
})

export default function App() {
  return (
    <ThemeProvider theme={theme}>
    <BrowserRouter>
      <Nav />
      <Routes>
        <Route index element={<Home />} />
        <Route path="Product" element={<Product />} />
        <Route path="Contact" element={<Contact />} />
      </Routes>
    </BrowserRouter>
    </ThemeProvider>

  );
}
